import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'scpi-other-transactions-last-year',
    templateUrl: './scpi-other-transactions-last-year.component.html',
    styleUrls: ['./scpi-other-transactions-last-year.component.scss'],
    standalone: false
})
export class ScpiOtherTransactionsLastYearComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
